module.exports = __webpack_public_path__ + "static/media/service.f986f4af.png";